import React, { useEffect, useRef, useState } from 'react';
import styles from '../Holiday/Holiday.module.css';
import CompanyCalander from "../../../Components/ResourceCalander/ResourceCalander";
import BookedLeaveTable from './BookedLeaveTable';
import { useMsal } from "@azure/msal-react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import '../../../Components/YesNoButtonsCSS/YesNoButtons.module.css';
import Table from '../../../Components/Table/TableV2.js'
import { useDispatch } from '../../../redux/store';
import {
  approveLeaveRequest,
  fetchAdminCalendarData,
  fetchAdminCalendarDataWithParams,
  fetchAdminHolidayOverviewRows,
  fetchAdminRequestedLeaveList,
  rejectLeaveRequest,
} from '../../../redux/slices/adminHr';

function Holiday() {
  const [reload, setReload] = useState(0);
  const [isFocused, setIsFocused] = useState(false);
  const [rows, setRows] = useState([]); 
  const [holidayOverviewRows, setHolidayOverviewRows] = useState([]); 
  const { accounts } = useMsal();
  const [loading, setLoading] = useState(false);
  const account = accounts[0]; 
  const [apiResponse, setApiResponse] = useState(null);
  const [isResponseShown, setIsResponseShown] = useState(false);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [calendarData, setCalendarData] = useState("");
  const dispatch = useDispatch();
  const loadPromisesRef = useRef([]);

  useEffect(() => {
    setLoading(true);

    (loadPromisesRef.current || []).forEach((p) => p?.abort?.());

    const requestedPromise = dispatch(fetchAdminRequestedLeaveList({ approversEmail: account.username }));
    const calendarPromise = dispatch(fetchAdminCalendarData());
    const overviewPromise = dispatch(fetchAdminHolidayOverviewRows());
    loadPromisesRef.current = [requestedPromise, calendarPromise, overviewPromise];

    Promise.all([requestedPromise.unwrap(), calendarPromise.unwrap(), overviewPromise.unwrap()])
      .then(([fetchedRequestedLeaveList, fetchedCalendarData, fetchedHolidayOverview]) => {
        setRows(fetchedRequestedLeaveList);
        setHolidayOverviewRows(fetchedHolidayOverview);
        setCalendarData(fetchedCalendarData);
        setIsDataFetched(true);
      })
      .catch((e) => {
        // Avoid unhandled rejections when a prior in-flight load is aborted (e.g. double navigation)
        if (e?.name === 'AbortError' || e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') return;
        console.error('Admin Holiday page load failed', e);
      })
      .finally(() => setLoading(false));

    return () => (loadPromisesRef.current || []).forEach((p) => p?.abort?.());
  }, [dispatch, reload, account.username]);

  const handleApproval = async (id) => {
    setLoading(true);
    try {
    const data = await dispatch(approveLeaveRequest({ leaveId: id, approversEmail: account.username })).unwrap();
    setApiResponse(data?.message || 'Leave approved.');
    setReload(reload + 1);
    } catch (error) {
      console.error("Error in handleCancelationReload:", error);
    } finally {
      setLoading(false);
    }
    setIsResponseShown(true);
  };

  const handleRejection = async (id, RejectionComment) => {
    setLoading(true);
    try {
    const data = await dispatch(rejectLeaveRequest({ leaveId: id, approversEmail: account.username, comment: RejectionComment })).unwrap();
    setApiResponse(data?.message || 'Leave rejected.');
    setReload(reload + 1);
    } catch (error) {
      console.error("Error in handleCancelationReload:", error);
    } finally {
      setLoading(false);
    }
    setIsResponseShown(true);
  };

  const CalanderAPItrigger = async (changeData) => {
    try {
      const data = await dispatch(fetchAdminCalendarDataWithParams({ params: changeData })).unwrap();
      setCalendarData(data);
    } catch (error) {
      console.error('Error:', error);
      setCalendarData('Error occurred');
    }
  }

  return (
    <>
      {isDataFetched ? (
        <div className={styles.mainContent}>
          {/* Company Calendar */}
          <div className={styles.content}>
            <div className={styles.title}>Company Calendar</div>
          </div>
          <div className={styles.content}>
            {calendarData ? (
              <CompanyCalander resourceData={calendarData} CalanderAPItrigger={CalanderAPItrigger} UserEmail={account.username} />
            ) : (
              <div>Loading calendar...</div>
            )}
          </div>

          <div className={styles.content}>
            <div className={styles.title}>Holiday Booking</div>
          </div>
          <div className={styles.approvalsHolidayManagment}>
            <div className={styles.bookedLeaveBox} style={{ display: isDataFetched ? 'block' : 'none' }}> 
              <BookedLeaveTable rows={rows} handleApproval={handleApproval} handleRejection={handleRejection}/>
            </div>
          </div>
          <div className={styles.content}>
            <div className={styles.title}>Holiday Overview</div>
          </div>
          <Table data={holidayOverviewRows} minHeight260={true}/>

          { loading ? // Here is the code for displaying error/success messages
              <div className={styles.ProfileHolidayOverlay}>
                <CircularProgress size={65} />
              </div>
              : 
              isResponseShown && (
                <div className={styles.ProfileHolidayOverlay}>
                  <div className={styles.ProfileHolidayResponseBox}>
                  <div
                    style={{
                      fontSize: 16,
                      fontFamily: 'PT Sans',
                      textAlign: 'center',
                      margin: '20px',
                      marginLeft: '25px',
                      marginRight: '25px'
                    }}
                  
                    dangerouslySetInnerHTML={{ __html: apiResponse }}
                    >
                  </div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button className={styles.ProfileHolidayButton}
                      onClick={() => setIsResponseShown(false)}
                    >
                      OK
                    </button>
                  </div>
                  </div>
                </div>
                )}
        </div>
      ) : (
        <Box sx={{display: 'flex', alignItems: 'flex-start', paddingTop: '250px', justifyContent: 'center'}}>
          <CircularProgress size={65} />
        </Box>
      )}
    </>
  );
}

export default Holiday;